<template>
  <page-wrapper :title="title">
    <div class="container">
      <sc-button
        class="create-button"
        variant="primary"
        @click="downloadFileReport"
        >Download Report</sc-button
      >
    </div>
  </page-wrapper>
</template>

<script>
import { backendAdminClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import {
  buildReportFilename,
  downloadBlob,
  hasReportPayload,
} from "../recurringReportDownload";

const EMPTY_REPORT_MESSAGE = "ไม่พบข้อมูลรายงาน";
const DOWNLOAD_ERROR_MESSAGE = "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง";

export default {
  name: "RecurringDownloadReportPage",
  components: {
    PageWrapper,
    ScButton,
  },
  data() {
    const title = "รายงานการตัดบัตร(Subscribe)";

    return {
      title,
    };
  },
  methods: {
    async downloadFileReport() {
      try {
        const response =
          await backendAdminClient.subscriptions.getRecurringNotifyReport();

        if (!hasReportPayload(response.data)) {
          this.$message.error(EMPTY_REPORT_MESSAGE);
          return;
        }

        downloadBlob(response.data, buildReportFilename());
      } catch {
        this.$message.error(DOWNLOAD_ERROR_MESSAGE);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.container {
  margin-top: 20px;
}
</style>
